module.exports = __webpack_public_path__ + "static/media/classifier.db5a39a9.svg";